import React, { useState, useEffect } from "react";
// import Breadcrumbs from "../../core/breadcrumbs";
import { Link, useNavigate } from "react-router-dom";
import { Filter, Sliders } from "react-feather";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Select from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Edit, Eye, Globe, Trash2, User, PlusCircle } from "react-feather";
import { Table } from "antd";
import CustomerModal from "../../core/modals/peoples/customerModal";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// import { setcustomer_data } from "../../core/redux/action";
import Axios from "axios";
import { API_BASE_URL, GET_CUSTOMERS } from "../../Config";
import AddCustomerModal from "../../core/modals/peoples/AddCustomerModal";
import SpinLoader from "../loader/SpinLoader";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

const Customers = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [customerObj, setCustomerObj] = useState(null); // Changed to null for object clarity
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [rechargeModalOpen, setRechargeModalOpen] = useState(false);
  const [selectedCustomerForRecharge, setSelectedCustomerForRecharge] =
    useState(null);
  const [rechargeAmount, setRechargeAmount] = useState("");
  const [rechargeError, setRechargeError] = useState("");
  const [rechargeLoading, setRechargeLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  // const [orgSettingsData, setOrgSettingsData] = useState(null);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);
  // useEffect(() => {
  //   const OrgSettings = sessionStorage.getItem("OrgSettings");
  //   if (OrgSettings) {
  //     const orgSettingsObj = JSON.parse(OrgSettings);
  //     setOrgSettingsData(orgSettingsObj);
  //   } else {
  //     console.log("OrgSettings not found ");
  //   }
  // }, []);

  const showEditModal = (cusObj) => {
    setCustomerObj(cusObj);
  };

  const showViewModal = (cusObj) => {
    setCustomerObj(cusObj);
  };

  const handleOpenRecharge = (record) => {
    setSelectedCustomerForRecharge(record);
    setRechargeAmount("");
    setRechargeError("");
    setRechargeModalOpen(true);
  };

  const handleCloseRecharge = () => {
    setRechargeModalOpen(false);
    setSelectedCustomerForRecharge(null);
    setRechargeAmount("");
    setRechargeError("");
  };

  const handleRechargeSubmit = async () => {
    if (!selectedCustomerForRecharge) return;

    console.log(selectedCustomerForRecharge, rechargeAmount, "payloaddddddd");
    const amountNum = Number(rechargeAmount.trim());

    if (!rechargeAmount || isNaN(amountNum) || amountNum <= 0) {
      setRechargeError("Please enter a valid positive amount");
      return;
    }

    setRechargeLoading(true);
    setRechargeError("");

    try {
      const payload = {
        orgid: userDataSession?.OrgId,
        custid: selectedCustomerForRecharge?.Id,
        amount: amountNum,
      };
      console.log(payload, "payloaddddddd");
      const response = await Axios.post(
        `${API_BASE_URL}Customer/RechargeCustomer`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      if (response.data) {
        // Success
        Swal.fire({
          icon: "success",
          title: "Success",
          text: `₹${amountNum} added to ${selectedCustomerForRecharge.Name}`,
          timer: 1800,
          showConfirmButton: false,
        });

        // Refresh list
        // Option A: Re-fetch from API (most reliable)
        const res = await Axios.get(
          `${API_BASE_URL}${GET_CUSTOMERS}?OrgId=${userDataSession?.OrgId}&CustomerId=0`,
        );
        if (res.data?.Status) {
          setData(res.data.ResultData);
        }

        // Option B: optimistic update (faster but assumes balance field exists)
        // setData(prev =>
        //   prev.map(c =>
        //     c.CustomerId === selectedCustomerForRecharge.CustomerId
        //       ? { ...c, Balance: (Number(c.Balance) || 0) + amountNum }
        //       : c
        //   )
        // );

        handleCloseRecharge();
      } else {
        setRechargeError(response.data?.Message || "Recharge failed");
      }
    } catch (err) {
      console.error(err);
      setRechargeError(
        err.response?.data?.Message ||
          "Something went wrong. Please try again.",
      );
    } finally {
      setRechargeLoading(false);
    }
  };

  const dispatch = useDispatch();
  // const data = useSelector((state) => state.customerdata);

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_CUSTOMERS}?OrgId=${userDataSession?.OrgId}&CustomerId=0`,
      )
        .then((response) => {
          if (response.data.Status) {
            // dispatch(setcustomer_data(response.data.ResultData));
            setData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [dispatch, userDataSession]);

  const options = [
    { value: "sortByDate", label: "Sort by Date" },
    { value: "140923", label: "14 09 23" },
    { value: "110923", label: "11 09 23" },
  ];
  const optionsTwo = [
    { label: "Choose Customer Name", value: "" },
    { label: "Benjamin", value: "Benjamin" },
    { label: "Ellen", value: "Ellen" },
    { label: "Freda", value: "Freda" },
    { label: "Kaitlin", value: "Kaitlin" },
  ];

  const countries = [
    { label: "Choose Country", value: "" },
    { label: "India", value: "India" },
    { label: "USA", value: "USA" },
  ];
  const handleDownload = () => {
    if (data.length === 0) return;
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, "Customers");
    XLSX.writeFile(wb, "Customers.xlsx");
  };

  const downloadPDF = () => {
    const doc = new jsPDF();

    const tableColumn = ["Name", "Email", "Mobile", "Balance"];

    const tableRows = data.map((item) => [
      item?.Name || "N/A",
      item?.Email || "N/A",
      item?.Mobile || "N/A",
      `${item?.Amount ?? 0} INR`,
    ]);

    doc.setFontSize(18);
    doc.text("Customers List", 14, 15);
    doc.setFontSize(10);
    // doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 22);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 30, // This ensures the table starts after the title (15 + some padding)
      theme: "grid",
      styles: { fontSize: 8 },
      headStyles: { fillColor: [40, 52, 70] },
      didDrawPage: (data) => {
        // This footer will now appear on EVERY page automatically
        const str = "Page " + doc.internal.getNumberOfPages();
        doc.setFontSize(10);
        const pageSize = doc.internal.pageSize;
        const pageHeight = pageSize.height
          ? pageSize.height
          : pageSize.getHeight();
        doc.text(str, data.settings.margin.left, pageHeight - 10);
      },
    });

    // 4. Save the PDF
    doc.save(`Customer_Report_${new Date().getTime()}.pdf`);
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const filteredData = data.filter((record) => {
    if (!searchText) return true; // show all when empty

    const search = searchText.toLowerCase().trim();

    return (
      (record.Name || "").toLowerCase().includes(search) ||
      (record.Mobile || "").toLowerCase().includes(search) ||
      (record.Email || "").toLowerCase().includes(search) ||
      (record.CardNumber || "").toLowerCase().includes(search)
    );
  });

  const columns = [
    {
      title: "Customer Name",
      dataIndex: "Name",
      sorter: (a, b) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Mobile",
      dataIndex: "Mobile",
      // sorter: (a, b) => a.Mobile.localeCompare(b.Mobile),
    },
    {
      title: "Email",
      dataIndex: "Email",
      // sorter: (a, b) => a.Email.localeCompare(b.Email),
    },
    // OrgType 12 means Canteen who have recharge Options
    ...(userDataSession?.OrgType === 12
      ? [
          {
            title: "Card No",
            dataIndex: "CardNumber",
          },
          {
            title: "Balance",
            dataIndex: "Amount",
            key: "Amount",
            render: (amount) => {
              // If amount is null, undefined, or empty, default to 0
              const value = amount ?? 0;

              // Format to Indian locale to get proper comma separation (e.g., 10,000)
              return `₹ ${value.toLocaleString("en-IN")}`;
            },
          },
        ]
      : []),
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <td className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>

            <Link
              className="me-2 p-2 "
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#view-units"
              onClick={() => showViewModal(record)}
            >
              <Eye className="feather-view" />
            </Link>

            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#edit-units"
              onClick={() => showEditModal(record)}
            >
              <Edit className="feather-edit" />
            </Link>
            {userDataSession?.OrgType === 12 && (
              <Link
                className="me-2 p-2 text-primary"
                to="#"
                title="Add Balance / Recharge"
                onClick={() => handleOpenRecharge(record)}
              >
                <i className="fas fa-indian-rupee-sign me-1"></i>
              </Link>
            )}
            <Link
              className="confirm-text p-2 d-none"
              to="#"
              onClick={() => showConfirmationAlert(record)} // Pass record for dynamic alert
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </td>
      ),
    },
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (record) => {
    // Added record param
    MySwal.fire({
      title: "Are you sure?",
      text: `You won't be able to revert deleting ${
        record?.Name || "this customer"
      }!`, // Dynamic text
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // TODO: Call delete API here, e.g., Axios.delete(...)
        MySwal.fire({
          title: "Deleted!",
          text: `${record?.Name || "Customer"} has been deleted.`,
          icon: "success", // Added icon for better UX
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        // Optionally refetch data after delete
      }
    });
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Customer List</h4>
              <h6>Manage Your Customers</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link
                  onClick={() => downloadPDF()}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                >
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link
                  onClick={() => handleDownload()}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                >
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link
              to="#"
              className="btn btn-added"
              data-bs-toggle="modal"
              data-bs-target="#add-units"
            >
              <PlusCircle className="me-2" />
            </Link>
          </div>
        </div>

        {/* <Breadcrumbs
          maintitle="Customer List"
          subtitle="Manage Your  Customers"
          addButton="Add New Customer"
        /> */}

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter d-none ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
              <div className="form-sort d-none stylewidth">
                <Sliders className="info-img" />

                <Select
                  className="select "
                  options={options}
                  placeholder="Sort by Date"
                />
              </div>
            </div>
            {/* /Filter */}
            <div
              className={`d-none  card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <User className="info-img" />
                      <Select
                        options={optionsTwo}
                        placeholder="Choose Customer Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <Globe className="info-img" />
                      <Select
                        options={countries}
                        placeholder="Choose Country"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                    <div className="input-blocks">
                      <a className="btn btn-filters ms-auto">
                        {" "}
                        <i
                          data-feather="search"
                          className="feather-search"
                        />{" "}
                        Search{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Filter */}
            <div className="table-responsive">
              {loading ? (
                // <div className="loader m-auto"></div>
                <SpinLoader />
              ) : data && data.length > 0 ? (
                <Table
                  className="table datanew"
                  columns={columns}
                  // dataSource={data}
                  dataSource={filteredData}
                  rowKey={(record) => record.Id || record.CustomerId}
                />
              ) : (
                <div className="text-center p-4">No customers found.</div>
              )}
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
      <CustomerModal customerObj={customerObj} />
      <AddCustomerModal />

      <div
        className={`modal fade ${rechargeModalOpen ? "show" : ""}`}
        style={{ display: rechargeModalOpen ? "block" : "none" }}
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Balance / Recharge</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseRecharge}
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="mb-3 col-6">
                  <label className="form-label">Customer Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedCustomerForRecharge?.Name || ""}
                    readOnly
                    disabled
                  />
                </div>

                <div className="mb-3 col-6">
                  <label className="form-label">
                    Amount <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className={`form-control ${rechargeError ? "is-invalid" : ""}`}
                    value={rechargeAmount}
                    onChange={(e) => {
                      setRechargeAmount(e.target.value);
                      setRechargeError("");
                    }}
                    placeholder="Enter amount"
                    min="1"
                    step="1"
                    onWheel={(e) => e.target.blur()}
                    autoFocus
                  />
                  {rechargeError && (
                    <div className="invalid-feedback">{rechargeError}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end mb-2 me-2">
              <button
                type="button"
                className="btn btn-sm btn-secondary me-2"
                onClick={handleCloseRecharge}
                disabled={rechargeLoading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={handleRechargeSubmit}
                disabled={rechargeLoading}
              >
                {rechargeLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Processing...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {rechargeModalOpen && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default Customers;
